import {BrowserRouter, Routes, Route} from 'react-router-dom';
import AccountChooser from './components/account-chooser';
import CookiesPermission from './components/cookies-permission';
import GenericError from './components/generic-error';
import {useBrand} from './components/app-context-provider';
import {useTheme} from '@telefonica/mistica';
import * as React from 'react';
import AccountManagement from './components/account-management';

import type {Locale} from '@telefonica/mistica';

const getLang = (locale: Locale): string => {
    const [lang] = locale.split('-');
    return lang;
};

const App = (): JSX.Element => {
    const {i18n} = useTheme();
    const lang = getLang(i18n.locale);

    React.useEffect(() => {
        document.documentElement.setAttribute('lang', lang);
    }, [lang]);

    return (
        // https://www.w3.org/International/questions/qa-html-language-declarations.en
        // https://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/translate
        <div lang={lang} translate="no">
            <BrowserRouter basename={useBrand()}>
                <Routes>
                    <Route path="/account-chooser" element={<AccountChooser />} />
                    <Route path="/account-chooser/management" element={<AccountManagement />} />
                    <Route path="/permission" element={<CookiesPermission />} />
                    <Route path="/error" element={<GenericError />} />
                    <Route path="*" element={<GenericError />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
};

export default App;
